import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 mb-4" }
const _hoisted_5 = { class: "row align-items-end" }
const _hoisted_6 = { class: "col-md-4 mb-3" }
const _hoisted_7 = { class: "col-md-4 mb-3" }
const _hoisted_8 = { class: "col-md-4 mb-3" }
const _hoisted_9 = { class: "col-md-4 mb-3" }
const _hoisted_10 = { class: "col-md-4 mb-3" }
const _hoisted_11 = { class: "col-md-12 mt-2" }
const _hoisted_12 = { class: "row mb-20" }
const _hoisted_13 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "badge text-bg-warning fs-13"
}
const _hoisted_17 = {
  key: 1,
  class: "badge text-bg-success fs-13"
}
const _hoisted_18 = {
  key: 4,
  class: "dropdown"
}
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 3 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.auth.can('SCORING'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
              type: "button",
              to: "/add-pointage-notes"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode(" Ajouter un bon de suivi livreur ", -1),
                _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
              ])),
              _: 1,
              __: [10]
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[12] || (_cache[12] = _createElementVNode("label", null, "Ramasseur", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.ramass_filter,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ramass_filter) = $event)),
            options: _ctx.RamassList,
            label: "name",
            placeholder: "Tous les ramasseurs",
            onSearch: _ctx.onSearchRamass
          }, {
            "no-options": _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode(" Taper un mot pour chercher un ramasseur ", -1)
            ])),
            _: 1
          }, 8, ["modelValue", "options", "onSearch"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[14] || (_cache[14] = _createElementVNode("label", null, "Statut", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.searchStatut) = $event))
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("option", { value: "" }, "Statut (Tous)", -1),
            _createElementVNode("option", { value: 0 }, "Brouillon", -1),
            _createElementVNode("option", { value: 1 }, "Enregistré", -1)
          ]), 512), [
            [_vModelSelect, _ctx.filters.searchStatut]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[16] || (_cache[16] = _createElementVNode("label", null, "Créé par", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.filters.searchUser,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.searchUser) = $event)),
            options: _ctx.UsersList,
            label: "name",
            reduce: (u) => u.id,
            placeholder: "Tous les utilisateurs",
            onSearch: _ctx.onSearchUsers
          }, {
            "no-options": _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode(" Taper un mot pour chercher un utilisateur ", -1)
            ])),
            _: 1
          }, 8, ["modelValue", "options", "reduce", "onSearch"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[17] || (_cache[17] = _createElementVNode("label", null, "Date", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.searchDate) = $event))
          }, null, 512), [
            [_vModelText, _ctx.filters.searchDate]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[18] || (_cache[18] = _createElementVNode("label", null, "Recherche", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Chercher...",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.searchTerm) = $event)),
            onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
          }, null, 544), [
            [_vModelText, _ctx.filters.searchTerm]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn btn-primary me-2",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
          }, " Filtrer "),
          _createElementVNode("button", {
            class: "btn btn-outline-danger",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
          }, " Annuler ")
        ])
      ]),
      _cache[28] || (_cache[28] = _createElementVNode("hr", { class: "mb-4" }, null, -1)),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[19] || (_cache[19] = _createElementVNode("label", null, "Voir", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.filters.per_page,
            "onUpdate:modelValue": [
              _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.per_page) = $event)),
              _cache[9] || (_cache[9] = ($event: any) => (_ctx.getRecords()))
            ],
            options: [10, 25, 50, 100],
            clearable: false,
            class: "per-page-selector d-inline-block mx-50"
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", null, "sur " + _toDisplayString(_ctx.filters.total) + " entités", 1)
        ])
      ]),
      _createVNode(_component_vue_good_table, {
        columns: _ctx.columns,
        rows: _ctx.rows
      }, {
        emptystate: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode("Aucune entrées correspondantes trouvées", -1)
            ])),
            _: 1,
            __: [20]
          })
        ]),
        "table-row": _withCtx((props) => [
          (props.column.field === 'note_ref')
            ? (_openBlock(), _createElementBlock("b", _hoisted_14, _toDisplayString(props.row.note_ref), 1))
            : (props.column.field === 'user_name')
              ? (_openBlock(), _createElementBlock("b", _hoisted_15, _toDisplayString(props.row.user_name), 1))
              : (props.column.field === 'created_at')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (props.row.created_at != null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)) + " ", 1),
                          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1))
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(props.row.note_by_name), 1)
                  ], 64))
                : (props.column.field === 'statut')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (props.row.statut == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Brouillon "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17, " Enregistré "))
                    ], 64))
                  : (props.column.field === 'action')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[27] || (_cache[27] = _createElementVNode("button", {
                          class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("i", { class: "flaticon-dots" })
                        ], -1)),
                        _createElementVNode("ul", _hoisted_19, [
                          _createElementVNode("li", null, [
                            (_ctx.auth.can('SCORING'))
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "dropdown-item d-flex align-items-center",
                                  to: {
                      name: 'PointageDetailsPage',
                      params: { id: props.row.id, ref: props.row.note_ref },
                    }
                                }, {
                                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                                    _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Détails ", -1)
                                  ])),
                                  _: 2,
                                  __: [22]
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true)
                          ]),
                          (props.row.statut == 0 && props.row.total_notes == 0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                (_ctx.auth.can('SCORING'))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "dropdown-item d-flex align-items-center",
                                      onClick: ($event: any) => (_ctx.removeNote(props.row))
                                    }, _cache[23] || (_cache[23] = [
                                      _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Supprimer ", -1)
                                    ]), 8, _hoisted_21))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (props.row.statut == 0 && props.row.total_notes != 0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                (_ctx.auth.can('SCORING'))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "dropdown-item d-flex align-items-center",
                                      onClick: ($event: any) => (_ctx.saveBon(props.row))
                                    }, _cache[24] || (_cache[24] = [
                                      _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Enregistrer ", -1)
                                    ]), 8, _hoisted_23))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (props.row.statut == 1)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                                (_ctx.auth.can('SCORING'))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "dropdown-item d-flex align-items-center",
                                      onClick: ($event: any) => (_ctx.unSaveBon(props.row))
                                    }, _cache[25] || (_cache[25] = [
                                      _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Ouvrir ", -1)
                                    ]), 8, _hoisted_25))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (props.row.total_notes != 0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                                _createElementVNode("button", {
                                  class: "dropdown-item d-flex align-items-center",
                                  onClick: ($event: any) => (_ctx.getPDF(props.row))
                                }, _cache[26] || (_cache[26] = [
                                  _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" PDF ", -1)
                                ]), 8, _hoisted_27)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["columns", "rows"]),
      _createVNode(_component_PaginatorContent, {
        pagination: _ctx.filters,
        offset: 9,
        onPaginate: _ctx.getRecords
      }, null, 8, ["pagination", "onPaginate"])
    ])
  ]))
}